<template lang="pug">
  component(
    v-if='component && album'
    :is='component'
    :album='album'
    :running='albumRunning'
    :removable='removable'
    :editable='editable'
    :review='review'
    :checkable='checkable'
    :checked='checked'
    :show-controls='showControls'
    @play='play'
    @pause='pause'
    @delete='deleteAlbum'
    @restore='restoreAlbum'
    @like='likeAlbum'
    @unlike='unlikeAlbum'
  )
</template>
<script>
import { mapActions } from "vuex";

import playerControlsMixin from "@/mixins/shared/playerControls.mixin";
import dinamicComponentMixin from "@/mixins/shared/dinamicComponent.mixin";

import cardTemplate from "./templates/card";
import fullTemplate from "./templates/full";

export default {
  props: {
    album: Object,
    removable: Boolean,
    editable: Boolean,
    review: Boolean,
    showControls: {
      type: Boolean,
      default: true
    },
    checkable: Boolean,
    checked: Boolean
  },
  data() {
    return {
      tracklist: {
        owner: true,
        id: this.album.id,
        tracks: this.album.tracks
      },
      templates: {
        card: cardTemplate,
        full: fullTemplate
      }
    };
  },
  mixins: [playerControlsMixin, dinamicComponentMixin],
  computed: {
    albumRunning() {
      return Boolean(
        this.running &&
          this.currentPlaylist &&
          this.currentPlaylist.id === this.album.id
      );
    }
  },
  methods: {
    ...mapActions({
      delete: "albums/delete",
      like: "albums/like",
      unlike: "albums/unlike"
    }),
    async deleteAlbum() {
      if (this.checkable) {
        return this.$emit("check");
      }

      await this.delete({
        id: this.album.id,
        type: this.type
      });
    },
    restoreAlbum() {
      this.$emit("uncheck");
    },
    likeAlbum() {
      this.like(this.album.id);
    },
    unlikeAlbum() {
      this.unlike(this.album.id);
    }
  }
};
</script>
